import { Dictionary } from "vue-router/types/router";
import { setLocalStorage } from "./localStorage";

export function initUserInfoByUrl(
  query: Dictionary<string | (string | null)[]>
) {
  const { token, city, long, lat, tel } = query;

  //存储url中的token
  if (token) {
    setLocalStorage("token", token as string);
    sessionStorage.setItem("code_details_token", token as string); //供券码详情（我要使用）项目使用
  }

  //存储url中的city门店列表页默认搜索使用
  if (city) {
    sessionStorage.setItem("city", city as string);
  }

  //存储url中的经纬度
  if (long && lat) {
    sessionStorage.setItem("long_lat", JSON.stringify({ long, lat }));
  }

  //存储url中的手机号
  if (tel) {
    sessionStorage.setItem("user_tel", tel as string);
  }
}
